Vue.component("data-overview", {
    props: ["user", "teams","sourcesOutOf"],

    data() {
        return {
            reportType: "xls",
            team_overview: this.getEmptyData(),
            past_team_overview: this.getEmptyData(),
            params: {
                fromDate: moment().startOf("year"),
                toDate: moment(),
                dateRange: "Year To Date",
                selectedReports: ["overview"]
            },
            overviewTerms: {
                positive: "",
                negative: ""
            },
            responseFilter: "",
            selectedRatingCategory: "overall_average",
            isLoading: true,
            exportModalCheckboxes: {
                overview: true,
                sentimentAnalysis: false,
                country: false,
                travelComposition: false,
                travelType: false,
                responses: false,
                guestFeedback: false
            },
            comparisonFromDate: moment()
                .subtract(1, "year")
                .startOf("year"),
            comparisonToDate: moment().subtract(1, "year"),
            comparisonDateRange: "Previous Year To Date",
            categories: [
                "overall",
                "cleanliness",
                "value",
                "location",
                "room",
                "service"
            ],
            externalSources: [
                'exclusivi',
                'hotel_feedback'
            ]
        };
    },

    computed: {
        exportLink() {
            const selectedReports = this.params.selectedReports
                .map(value => `selectedReports[]=${value}`)
                .join("&");
            return (
                "/report/hotel/" +
                Spark.state.currentTeam.id +
                "/adhoc?comparePreviousType=previous_period" +
                "&fromDate=" +
                this.params.fromDate +
                "&toDate=" +
                this.params.toDate +
                "&" +
                selectedReports +
                "&report_type=" +
                this.reportType +
                `&comparisonFromDate=${this.comparisonFromDate.format(
                    "YYYY-MM-DD"
                )}&comparisonToDate=${this.comparisonToDate.format(
                    "YYYY-MM-DD"
                )}`
            );
        },
        nonPositiveReviews() {
            total =
                parseInt(this.team_overview.reviews_total_negative) +
                parseInt(this.team_overview.reviews_total_neutral);

            return total;
        },
        formattedParams() {
            let newParams = this.params;

            try {
                newParams.toDate = newParams.toDate.format("YYYY-MM-DD");
                newParams.fromDate = newParams.fromDate.format("YYYY-MM-DD");
            } catch (error) {
                //
            }

            return newParams;
        },
        numOfResponded() {
            if (
                this.team_overview.responses &&
                this.team_overview.responses.all_sources
            ) {
                return this.team_overview.responses.all_sources.replied_reviews;
            }

            return 0;
        },

        numOfNotResponded() {
            if (
                this.team_overview.responses &&
                this.team_overview.responses.all_sources
            ) {
                return this.team_overview.responses.all_sources.not_responded;
            }

            return 0;
        },
        hasSelectedReports() {
            return this.params.selectedReports.length;
        },
        ratingsCountByActiveCategory() {
            if (
                this.team_overview.ratings_by_category[
                    this.selectedRatingCategory
                ] !== undefined
            ) {
                return this.team_overview.ratings_by_category[
                    this.selectedRatingCategory
                ].count;
            } else {
                return this.team_overview.reviews_total_count;
            }
        },
        hasExternalReviews() {
            let feedbackBreakdown = undefined;
            if (this.user && Array.isArray(this.spark.userPreferences)) {
                const preference = this.spark.userPreferences.find(p => p.team_id === this.user.current_team_id);
                
                if (preference && typeof preference?.settings?.feedback_breakdown !== 'undefined') {
                    feedbackBreakdown = preference.settings.feedback_breakdown;      
                }
            }

            if (feedbackBreakdown !== 1) {
                return false;
            }
            
            if (!this.team_overview || !this.team_overview.ratings_by_source) {
                return false;
            }

            return Object.keys(this.team_overview.ratings_by_source)
                .some(key => this.externalSources.includes(key)) ||
                Object.keys(this.past_team_overview.ratings_by_source)
                .some(key => this.externalSources.includes(key));
        }
    },

    mounted() {
        this.$eventHub.$on("goToSourceReviews", source =>
            this.filterReviewsBySource(source)
        );

        // Determine from the backend the from/toDates for which reviews exist; use these as params for fetching overview data
        // Sync these dates with Reviews Filter Dates as well (except for when a 'from' param is present in the URL: in this case, Reviews will show just this date's Reviews)
        let url = new URL(window.location.href);
        var syncReviewsDates = !url.searchParams.get("from");

        this.getAndUseInitialDateParams(syncReviewsDates);

        let instance = this;

        this.$eventHub.$on(
            "update-home-dates",
            (fromDate, toDate, dateRangeString) => {
                instance.params["fromDate"] = fromDate;
                instance.params["toDate"] = toDate;
                instance.params["dateRange"] = dateRangeString;

                instance.loadOverviewData(instance.params);
            }
        );
    },

    methods: {
        comparisonDatesChanged(fromDate, toDate) {
            this.comparisonFromDate = moment(fromDate);
            this.comparisonToDate = moment(toDate);
            this.comparisonDateRange =
                this.comparisonFromDate.format("D MMM YYYY") +
                " - " +
                this.comparisonToDate.format("D MMM YYYY");
        },
        reportTypes() {
            return ["overview"];
        },

        setSelectedReportType(type) {
            this.reportType = type;
        },
        selectCategory(category) {
            this.selectedRatingCategory = category;
        },

        categoryScore(category, past = false) {
            let overview = past ? this.past_team_overview : this.team_overview;

            if (typeof overview.ratings_by_category[category] !== "undefined") {
                return overview.ratings_by_category[category].average;
            } else {
                return "-";
            }
        },

        formatCategoryScore(score) {
            if (score === "-") {
                return "N/A";
            }

            let calcScore = score * 20;

            if (calcScore == 100) {
                return "100%";
            }

            return calcScore.toFixed(1) + "%";
        },

        openReportExportModal(event, type = "xls") {
            this.setSelectedReportType(type);
            analytics.track("Clicked Export", {
                feature: "export_report",
                from_page: "overview"
            });
        },

        updateSelectedReports(key, value) {
            const keyIndex = this.params.selectedReports.findIndex(
                item => item === key
            );

            analytics.track("Changed Included Reports", {
                feature: "export_report",
                from_page: "overview"
            });

            if (keyIndex > -1)
                return this.params.selectedReports.splice(keyIndex, 1);
            this.params.selectedReports.push(key);
        },
        downloadReport() {
            analytics.track("Downloaded Report", {
                feature: "export_report",
                from_page: "overview",
                params: this.params
            });

            this.$notify({
                group: "reviews",
                title: "Success!",
                text:
                    "Your report is being downloaded! Within a few seconds it will be stored.",
                position: "bottom right",
                duration: 5000
            });

            $("#select-reports-to-export-modal").modal("hide");
        },
        getEmptyData() {
            return {
                ratings_total_average: "0",
                ratings_total_average_online: "0",
                ratings_total_average_feedback: "0",
                reviews_total_count: 0,
                reviews_total_positive: "0",
                reviews_total_negative: "0",
                reviews_total_neutral: "0",
                ratings_by_source: {
                    trip_advisor: {
                        average: 0,
                        count: 0,
                        out_of: 0,
                        response_rate: "100.00",
                        positive: "0",
                        negative: "0"
                    },
                    booking_com: {
                        average: 0,
                        count: 0,
                        out_of: 0,
                        response_rate: "100.00",
                        positive: "0",
                        negative: "0"
                    }
                },
                ratings_by_travel_composition: {},
                ratings_by_topic: {},
                ratings_by_category: {},
                sentiment_total_average: 0,
                sentiment_by_category: {},
                rankings: {},
                responses: {
                    all_sources: {
                        response_rate: "0",
                        replied_reviews: "0",
                        not_responded: "0",
                        important_not_responded: "0"
                    }
                },
                name: "...",
                star_counts: [0, 0, 0, 0, 0],
                goals: [],
                rankings_older: {}
            };
        },
        getAndUseInitialDateParams(syncReviewsDates) {
            axios
                .get(
                    "/api/overview/" +
                        Spark.state.currentTeam.id +
                        "/dates-with-data"
                )
                .then(response => {
                    this.params.fromDate = response.data.fromDate;
                    this.params.toDate = response.data.toDate;
                    this.params.dateRange = __(response.data.dateRange);

                    if (syncReviewsDates) {
                        this.$eventHub.$emit(
                            "update-home-dates-for-reviews",
                            response.data.fromDate,
                            response.data.toDate,
                            __(response.data.dateRange)
                        );
                    }

                    this.$eventHub.$emit(
                        "update-home-dates",
                        response.data.fromDate,
                        response.data.toDate,
                        __(response.data.dateRange)
                    );
                })
                .catch(error => {
                    this.handleAxiosError(
                        "overview.js: getAndUseInitialDateParams: Failed to get dates: ",
                        error,
                        false
                    );
                    // Show something anyway
                    this.loadOverviewData(this.formattedParams);
                });
        },

        getSourceGoals(sourceName) {
            return this.team_overview.goals.filter(function(goal) {
                return goal.source == sourceName;
            });
        },

        filterReviewsBySource(sourceName) {
            // This will cancel any un-related filters previously applied
            // to the reviews page
            params = this.getOriginalReviewFilters();

            // Now we apply the actual filters that are needed to get the
            // relevant information
            params["source"] = sourceName;
            params["fromDate"] = this.params["fromDate"];
            params["toDate"] = this.params["toDate"];

            this.$eventHub.$emit("applyFilters", params);
            this.$eventHub.$emit(
                "update-home-dates-for-reviews",
                this.params["fromDate"],
                this.params["toDate"],
                this.params["dateRange"]
            );

            $('.spark-settings-tabs a[href$="#reviews"]').tab("show");
        },

        loadOverviewData(params) {
            this.team_overview = this.getEmptyData();
            this.isLoading = true;

            var params_string = Object.keys(params)
                .map(function(k) {
                    return (
                        encodeURIComponent(k) +
                        "=" +
                        encodeURIComponent(params[k])
                    );
                })
                .join("&");

            axios
                .get(
                    "/api/terms/" +
                        Spark.state.currentTeam.id +
                        "/best-worst/?" +
                        params_string
                )
                .then(response => {
                    this.overviewTerms = response.data;
                });

            axios
                .get(
                    "/api/overview/" +
                        Spark.state.currentTeam.id +
                        "/?" +
                        params_string
                )
                .then(response => {
                    this.isLoading = false;

                    if (response.data.length == 2) {
                        this.team_overview = response.data[0];
                        this.past_team_overview = response.data[1];

                        this.$eventHub.$emit(
                            "updatePieChart",
                            this.team_overview["ratings_by_source"]
                        );
                    } else {
                        this.team_overview = [];
                    }
                });
        },
        showNotResponded() {
            this.responseFilter = "noResponse";
            this.filterReviews();
        },
        filterReviews() {
            var data = this.getOriginalReviewFilters();

            data["fromDate"] = this.params["fromDate"];
            data["toDate"] = this.params["toDate"];
            data["responseFilter"] = this.responseFilter;

            this.$eventHub.$emit("applyFilters", data);
            this.$eventHub.$emit(
                "update-home-dates-for-reviews",
                this.params["fromDate"],
                this.params["toDate"],
                this.params["dateRange"]
            );

            $('.spark-settings-tabs a[href$="#reviews"]').tab("show");
        },
        filterReviewsByRatingCategory() {
            let data = {
                terms: "",
                fromDate: this.params["fromDate"],
                toDate: this.params["toDate"],
                ratingsCategory: this.selectedRatingCategory
            };
            this.$eventHub.$emit("applyFilters", data);
            $('.spark-settings-tabs a[href$="#reviews"]').tab("show");
        }
    }
});
